var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessCheck = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 45,
  viewBox: "0 0 44 45",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2183_10134)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.0099 3.39062C32.6396 3.39062 41.26 12.0111 41.26 22.6407C41.26 33.2704 32.6396 41.8909 22.0099 41.8909C11.3802 41.8909 2.75977 33.2704 2.75977 22.6407C2.75977 12.0111 11.3802 3.39062 22.0099 3.39062ZM18.0124 28.8933L13.2995 24.1765C12.4965 23.3731 12.4964 22.063 13.2995 21.2598C14.1027 20.4567 15.4186 20.4618 16.216 21.2598L19.5386 24.585L27.804 16.3195C28.6073 15.5163 29.9175 15.5163 30.7206 16.3195C31.5239 17.1226 31.5227 18.434 30.7206 19.2361L20.9945 28.9622C20.1924 29.7643 18.881 29.7654 18.078 28.9622C18.0554 28.9396 18.0336 28.9167 18.0124 28.8933Z",
  fill: "#00BA00"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2183_10134"
}, /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  fill: "white",
  transform: "translate(0 0.629883)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/successCheck.e766f909b2760e6ca8e17b2d12e15df9.svg";